(function () {
  'use strict';

  if (window.BiossConjugationOverlayBehaviorStarted) return;
  window.BiossConjugationOverlayBehaviorStarted = true;

  function closestCard(el) {
    return el && el.closest ? el.closest('.box.product, .product-card, .product-item') : null;
  }


  function setOpenState(details, isOpen) {
    var card = closestCard(details);
    if (!card) return;

    card.classList.toggle('bioss-conj-card-open', !!isOpen);

    var figcaption = card.querySelector && card.querySelector('figcaption');
    var header = card.querySelector && card.querySelector('header');
    var description = card.querySelector && card.querySelector('.description');

    [figcaption, header, description].forEach(function (el) {
      if (!el || !el.classList) return;
      el.classList.toggle('bioss-conj-overlay-active', !!isOpen);
    });
  }

  function closeOtherDetails(activeDetails) {
    document.querySelectorAll('.bioss-conj-details[open]').forEach(function (details) {
      if (details !== activeDetails) {
        details.removeAttribute('open');
        setOpenState(details, false);
      }
    });
  }

  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (!details || !details.matches || !details.matches('.bioss-conj-details')) return;

    var card = closestCard(details);

    if (details.open) {
      closeOtherDetails(details);
      setOpenState(details, true);
    } else {
      setOpenState(details, false);
    }
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest && event.target.closest('.bioss-conj-options')) return;

    document.querySelectorAll('.bioss-conj-details[open]').forEach(function (details) {
      details.removeAttribute('open');
      setOpenState(details, false);
    });
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('.bioss-conj-details[open]').forEach(function (details) {
      details.removeAttribute('open');
      setOpenState(details, false);
    });
  });
})();
